/* eslint-disable @typescript-eslint/no-explicit-any */
import { groupSheet } from './system';
export const reapply = (doc, remove = true) => {
    if (!groupSheet) {
        return;
    }
    const document = doc !== null && doc !== void 0 ? doc : window.document;
    const names = Object.keys(groupSheet.rules);
    const newMediaRules = [];
    const oldStyleSheet = findStitchesStylesheet();
    const newStyle = document.createElement('style');
    newStyle.id = 'stitches';
    document.head.append(newStyle);
    const newSheet = newStyle.sheet;
    for (const cssRule of groupSheet.sheet.cssRules) {
        newSheet === null || newSheet === void 0 ? void 0 : newSheet.insertRule(cssRule.cssText, newSheet.cssRules.length);
    }
    for (const cssRule of newSheet.cssRules) {
        if (cssRule.media) {
            newMediaRules.push(cssRule);
        }
    }
    for (const [i, mediaRule] of newMediaRules.entries()) {
        const name = names[i];
        if (groupSheet.rules[name]) {
            groupSheet.rules[name].group = mediaRule;
            addApplyToGroup(groupSheet.rules[name]);
        }
    }
    groupSheet.sheet = newSheet;
    if (remove && (oldStyleSheet === null || oldStyleSheet === void 0 ? void 0 : oldStyleSheet.ownerNode)) {
        oldStyleSheet.ownerNode.remove();
    }
};
const findStitchesStylesheet = () => {
    var _a;
    for (const stylesheet of document.styleSheets) {
        if (isSheetAccessible(stylesheet) &&
            ((_a = stylesheet.cssRules[0]) === null || _a === void 0 ? void 0 : _a.cssText.includes('--sxs'))) {
            return stylesheet;
        }
    }
};
const addApplyToGroup = (group) => {
    const groupingRule = group.group;
    let index = groupingRule.cssRules.length;
    group.apply = (cssText) => {
        try {
            groupingRule.insertRule(cssText, index);
            ++index;
        }
        catch {
            // do nothing and continue
        }
    };
};
const isSheetAccessible = (sheet) => {
    if (sheet.href && !sheet.href.startsWith(location.origin)) {
        return false;
    }
    try {
        return !!sheet.cssRules;
    }
    catch {
        return false;
    }
};
